import { render, staticRenderFns } from "./IconCollapse.vue?vue&type=template&id=31c5019a&"
import script from "./IconCollapse.vue?vue&type=script&lang=js&"
export * from "./IconCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports